import { isChatChannel } from "../channels/types";
import type { FollowUpChannelWithData } from "./reducer/schema";
import type { FollowUp } from "./server/follow-up-service";

export function isChatChannelWithData(
  channel: FollowUpChannelWithData,
): channel is Extract<FollowUpChannelWithData, { channel: "slack" | "teams" }> {
  return isChatChannel(channel.channel);
}

export function isEmailChannelWithData(
  channel: FollowUpChannelWithData,
): channel is Extract<FollowUpChannelWithData, { channel: "work_email" | "personal_email" }> {
  return channel.channel === "work_email" || channel.channel === "personal_email";
}

export function isFollowUpWithConfig(
  followUp?: FollowUp | null,
): followUp is Omit<FollowUp, "config"> & { config: NonNullable<FollowUp["config"]> } {
  return (
    followUp !== null &&
    followUp !== undefined &&
    followUp.config !== null &&
    followUp.config !== undefined
  );
}
